<template>
  <div class="l_invitation_info">
    <p>香の川製麺公式アプリをお友だちに<br>
      紹介すると二人ともHappy♪</p>
    <h3>お友だちを紹介して<br>
      スタンプを{{ this.inviterPoint }}個プレゼント！</h3>
    <p class="small">
      ※通常2スタンプ。キャンペーン期間中はスタンプ数が異なる場合がございます
    </p>
    <h4>お友だち紹介を利用するには</h4>
    <hr/>
    <p class="body-text">①アプリ内の「お友だち紹介」ページから、「紹介リンクを送る」をタップ。</p>
    <p class="body-text">
      ②紹介されたお友だちが、<span>新規に香の川製麺アプリをインストール</span>し、<span>新規会員登録（無料）</span>すると、「お友だち紹介スタンプ」がもらえます。<br/>※紹介リンクには、7日間の有効期限があります。
    </p>
    <p class="body-text">③さらに、紹介されたお友だちが、<span>香の川製麺店舗に来店して、来店スタンプをGET</span>すると、あなたにも「お友だち紹介スタンプ」がもらえます。
      <br/>※紹介メール送信後、30日以内の来店が対象になります。
    </p>
    <h4>その他ご利用条件</h4>
    <hr/>
    <p class="other-info-title">ーご紹介者ー</p>
    <p class="body-text">
      ・紹介リンクは、メールはLINEなど、お好きなツールでお送りいただけます。（LINEアプリ、またはiOSの方はiPhoneメールアプリ、Androidの方はgmailアプリを推奨。その他のアプリをご利用された場合、正常に動作しない可能性がございます。）<br/>
      ・紹介リンクは、発行から7日間の有効期限があります。<br/>
      ・紹介者が1日に紹介できる人数は1人までです。 「紹介リンクを送る」ボタン押下後のポップアップ内の「送信する」ボタンを押すと送信したものとしてカウントされます。（1日1人の上限は、24:00にリセットされます。）<br/>
      ・紹介リンクの有効期限内にお友だちが新規会員登録（無料）されなかった場合は、お友だち紹介スタンプの対象となりません。<br/>
      ・お友だち紹介スタンプは、紹介リンクを送られたお友だちが、紹介リンク送信後30日以内に初回来店し、来店スタンプを獲得された場合、お友だち1人につき1度だけ獲得できます。<br/>
      ・複数のお友だちに同じリンクを送られた場合、一番最初に新規会員登録されたお友だちがスタンプ獲得の対象となります。<br/>
      *「新規会員登録」:ジョイフル公式アプリダウンロード後、「プロフィール設定」画面の「設定するボタン」を押した時点で「新規会員登録」となります。<br/>
      ・紹介したお友だちの来店による紹介スタンプは、紹介したお友だち1人につき1回までとなります。同じお友だちに何度も紹介リンクを送った場合も、初回の来店のみスタンプ付与の対象とさせていただきます。
    </p>
    <p class="other-info-title">ー紹介されたお友だちー</p>
    <p class="body-text">
      ・紹介されたお友だちが、お友だち紹介スタンプを受け取れるのは、紹介メッセージを受信後、1週間以内に、初めて香の川製麺アプリで新規会員登録したタイミングです。<br/>
      ・iOSの方は紹介メッセージ内のリンクを開く際のブラウザは、Safari推奨です。<br/>
      *「新規会員登録」:ジョイフル公式アプリダウンロード後、「プロフィール設定」画面の「設定するボタン」を押した時点で「新規会員登録」となります。<br/>
      ・複数のお友だちから招待された場合も、初回の1回だけが、お友だち紹介スタンプの対象となります。<br/>
      ・別のお友だちと同じ紹介リンクを受け取った場合、一番最初に会員登録されたお友だちがスタンプ獲得の対象となります。<br/>
      ・紹介リンクを送られてから、30日以内に来店スタンプを獲得された場合、紹介したお友だちに紹介スタンプが付与されます。<br/>
      ・来店によるお友だちへの紹介スタンプは、1人1回までとなります。お友だちから何度も紹介された場合も、初回の来店のみスタンプ付与の対象とさせていただきます。<br/>
      ・紹介スタンプ獲得後にジョイフル公式アプリをアンインストールされ、 後日改めて新規のお友達紹介リンクよりジョイフル公式アプリをインストールされた場合、 紹介スタンプは獲得出来ません。
    </p>
  </div>
</template>

<script>
  import APIClient, { ErrorCode } from '../api/APIClient'
  import DateFormatter from '../utils/DateFormatter'
  import { mapActions } from 'vuex'

  export default {
  name: 'FAQInvitationInfo',
  data: function () {
    return {
      inviterPoint: 2
    }
  },
  created() {
    document.title = 'アプリをお友だちに紹介'

    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchInvitationMasters(json.app_token, json.acc_time, json.user_id, json.client_id)
        window.receivedToken = null
      }
      this.actionRequestToken({
        apiType: '9',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Native', [
      'actionRequestToken'
    ]),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    async fetchInvitationMasters(token, accTime, userId, clientId) {
      this.actionToggleLoading(true)
      this.action_ToggleModal(true)
      const res = await APIClient.getInvitationMasterList(token, accTime, userId, clientId, '')
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        this.inviterPoint = parseInt(res.data.data.invitation_master_data[0].inviter_point, 10)
      }
      this.actionToggleLoading(false)
      this.action_ToggleModal(false)
    }
  }
}
</script>

<style scoped lang="scss">
.l_invitation_info {
  padding: 30px 20px;
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_invitation_info .other-info-title {
  font-weight: 600;
  font-size: 14px;
  padding-top: 24px;
  color: #602209;
  text-align: center;
}

.l_invitation_info h3 {
  padding-top: 10px;
  color: #602209;
  text-align: center;
}

.l_invitation_info h4 {
  padding-top: 40px;
  color: #602209;
  text-align: left;
}

.l_invitation_info hr {
  margin-top: 10px;
  border: none;
  border-bottom: 1px solid #efb90f;
}
.l_invitation_info img {
  width: 100%;
  padding-top: 16px;
}
.l_invitation_info .body-text {
  padding-top: 10px;
  text-align: left;
  font-size: 14px;
  color: #333333;
}

.l_invitation_info .body-text span {
  font-weight: 600;
}

.l_invitation_info .info-1 {
  width: 50%;
}

.l_invitation_info .invitation-info-img {
  margin-top: 28px;
  margin-bottom: 28px;
}

.small {
  margin-top: 10px;
  font-size: 14px;
  text-align: left;
  color: #888;
}
</style>
